export default __webpack_public_path__ + "static/media/logo.bf0e0b30.webp";